<script>
	let posts = [
		{
			id: 1,
			slug: 'introducing-os-studio',
			title: 'Introducing OS Studio: Build Operating Systems with AI',
			excerpt: 'We\'re excited to launch OS Studio, the first AI-powered platform for building complete operating systems.',
			date: '2026-02-01',
			author: 'Team',
			category: 'Announcement'
		},
		{
			id: 2,
			slug: '10x-faster-time-to-market',
			title: '10x Faster Time to Market with AI-Generated Code',
			excerpt: 'Learn how OS Studio reduces development time from months to weeks through AI code generation.',
			date: '2026-01-25',
			author: 'Engineering',
			category: 'Tips'
		},
		{
			id: 3,
			slug: 'techcorp-case-study',
			title: 'Case Study: How TechCorp Built Their System in 2 Weeks',
			excerpt: 'See how a mid-size tech company used OS Studio to deploy their entire operating system.',
			date: '2026-01-15',
			author: 'Success Team',
			category: 'Case Study'
		}
	];
</script>

<svelte:head>
	<title>Blog - OS Studio</title>
	<meta name="description" content="Read the latest news, tips, and case studies from OS Studio." />
</svelte:head>

<div class="min-h-screen bg-white">
	<!-- Header -->
	<div class="bg-gradient-to-br from-purple-900 to-blue-900 text-white py-20">
		<div class="container mx-auto px-4 max-w-6xl text-center">
			<h1 class="text-5xl font-bold mb-4">OS Studio Blog</h1>
			<p class="text-xl text-purple-100">Stories, tips, and insights from building the future of operating systems</p>
		</div>
	</div>

	<!-- Blog Posts -->
	<div class="container mx-auto px-4 max-w-6xl py-20">
		<div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
			{#each posts as post (post.id)}
				<div class="border border-gray-200 rounded-lg p-8 hover:border-purple-300 transition-colors">
					<div class="flex items-center gap-2 mb-3">
						<span class="text-xs font-semibold text-purple-600 bg-purple-50 px-3 py-1 rounded-full">
							{post.category}
						</span>
					</div>
					<h3 class="text-2xl font-bold text-gray-900 mb-3 hover:text-purple-600">
						<a href={`/blog/${post.slug}`}>{post.title}</a>
					</h3>
					<p class="text-gray-600 mb-4">{post.excerpt}</p>
					<div class="flex items-center justify-between text-sm text-gray-500">
						<span>By {post.author}</span>
						<span>{new Date(post.date).toLocaleDateString()}</span>
					</div>
					<a href={`/blog/${post.slug}`} class="text-purple-600 font-semibold hover:text-purple-700 mt-4 inline-block">
						Read More →
					</a>
				</div>
			{/each}
		</div>
	</div>
</div>
